import React from 'react';

function FeaturesSection() {
  const features = [
    {
      icon: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/d9eb4e57d4838cbe7814b187d582f26d66cf9fa5?placeholderIfAbsent=true",
      title: "Free shipping",
      description: " Enjoy Free delivery on all orders — no minimum purchase required."
    },
    {
      icon: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/b5356afd21cbdd88279f94af2e575f28caa8d685?placeholderIfAbsent=true",
      title: "Free in store return",
      description: "Return your online purchases easily at any of our stores, free of charge."
    },
    {
      icon: "https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/2ba1889795b5949758eb10d07c6e749351c2c69b?placeholderIfAbsent=true",
      title: "100% secure checkout",
      description: "Shop confidently — your payment and personal details are fully protected."
    }
  ];

  return (
    <section className="w-full max-w-[90%] mx-auto mt-11 px-4 max-md:mt-10 max-md:px-2">
      <div className="flex flex-col lg:flex-row justify-between items-start gap-8 max-md:gap-6">
        {features.map((feature, index) => (
          <div key={index} className="flex gap-4 items-center flex-1 min-w-0">
            <div className="flex-shrink-0">
              <img
                src={feature.icon}
                alt=""
                className="object-contain aspect-square w-[55px] max-md:w-[45px]"
              />
            </div>
            <div className="text-neutral-700 min-w-0">
              <h3 className="text-2xl font-medium uppercase max-md:text-xl">{feature.title}</h3>
              <p className="mt-2 text-xl max-md:text-lg">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeaturesSection;
